import { BasketItemQuoteDetails, PaymentOption } from '@basket';
import { CheckoutCompletedItem } from '../models/checkout-completed-item/checkout-completed-item.interface';
import { CheckoutItemDetails } from '../models/checkout-item/checkout-item-details.interface';
import { CheckoutRequest } from '../models/checkout/checkout-request.interface';
import { CheckoutResponse } from '../models/checkout/checkout-response.interface';

export function removeUnusedCheckoutCompletedItemQuotes(
  items: CheckoutItemDetails[],
  completedItems: CheckoutCompletedItem[],
): CheckoutCompletedItem[] {
  const quoteIds: string[] = items.map(
    (item: CheckoutItemDetails) => item.quoteId,
  );

  return completedItems.map(
    (completedItem: CheckoutCompletedItem) =>
      ({
        ...completedItem,
        item: {
          ...completedItem.item,
          data: {
            ...completedItem.item.data,
            quotes: completedItem.item.data.quotes.filter(
              (quote: BasketItemQuoteDetails) =>
                quoteIds.includes(quote.quoteId),
            ),
          },
        },
      }) as CheckoutCompletedItem,
  );
}

export function removeUnusedCheckoutCompletedItemPaymentOptions(
  request: CheckoutRequest,
  completedItems: CheckoutCompletedItem[],
): CheckoutCompletedItem[] {
  return completedItems.map(
    (completedItem: CheckoutCompletedItem) =>
      ({
        ...completedItem,
        item: {
          ...completedItem.item,
          data: {
            ...completedItem.item.data,
            quotes: completedItem.item.data.quotes.map(
              (quote: BasketItemQuoteDetails) => ({
                ...quote,
                paymentOptions: quote.paymentOptions.filter(
                  (paymentOption: PaymentOption) =>
                    paymentOption.paymentType === request.payment.paymentType,
                ),
              }),
            ),
          },
        },
      }) as CheckoutCompletedItem,
  );
}

export function formatCheckoutCompletedItems(
  request: CheckoutRequest,
  response: CheckoutResponse,
): CheckoutCompletedItem[] {
  let completedItems: CheckoutCompletedItem[] =
    removeUnusedCheckoutCompletedItemQuotes(
      request.items,
      response.completedItems,
    );

  completedItems = removeUnusedCheckoutCompletedItemPaymentOptions(
    request,
    completedItems,
  );

  return completedItems;
}
